import React from "react";

type _IProps = {};
type _IState = {};

export default class BasePage<IProps = _IProps, IState = _IState> extends React.Component<IProps, IState> {}
